import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled } from '@mui/system';
import { PROMETHEAN_BLUE, PROMETHEAN_DARK_PURPLE, PROMETHEAN_NEUTRAL_WHITE } from '../styles/colors/colors';
import { PROMETHEAN_BREAKPOINT_NAV_CHANGE } from '../styles/breakpoints/breakpoints';
import { PROMETHEAN_TYPOGRAPHY_BODY } from '../styles';
export var EMBERS_HEADER_HEIGHT = 56;
export var EMBERS_HEADER_HEIGHT_MOBILE = 48;
export var EMBERS_SIMPLE_HEADER_HEIGHT = 64;
export var StyledHeader = styled('div')(function () {
  return {
    '&.EmbersHeader-root': _defineProperty(_defineProperty(_defineProperty({
      width: '100%',
      height: EMBERS_HEADER_HEIGHT,
      backgroundColor: PROMETHEAN_DARK_PURPLE,
      position: 'fixed',
      zIndex: 1300,
      display: 'flex',
      flexDirection: 'row',
      overflow: 'hidden',
      '&.EmbersHeader-portal': {
        justifyContent: 'center',
        marginLeft: '-65px',
        marginRight: '-65px',
        marginTop: '-96px',
        marginBottom: '40px',
        '.EmbersHeader-logo': {
          margin: '0',
          cursor: 'pointer'
        }
      },
      '.EmbersHeader-app': {
        padding: '14px 18px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(255, 255, 255, .2)',
        cursor: 'pointer',
        '.apps-button': {
          border: '2px solid transparent',
          color: PROMETHEAN_NEUTRAL_WHITE
        },
        '.icon-apps-fill': {
          display: 'none'
        },
        '&:hover': {
          '.icon-apps': {
            display: 'none'
          },
          '.icon-apps-fill': {
            display: 'block'
          }
        },
        '&:focus-visible': {
          '.icon-apps': {
            display: 'none'
          },
          '.icon-apps-fill': {
            border: "2px solid ".concat(PROMETHEAN_NEUTRAL_WHITE),
            display: 'block'
          }
        }
      },
      '.EmbersHeader-app-appSwitcherOpen': {
        '.icon-apps': {
          display: 'none'
        },
        '.icon-apps-fill': {
          display: 'block'
        }
      },
      '.EmbersHeader-mainContent': {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        '.EmbersHeader-rightContent': {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center'
        }
      }
    }, "@media screen and (max-width:".concat(PROMETHEAN_BREAKPOINT_NAV_CHANGE, "px)"), {
      height: EMBERS_HEADER_HEIGHT_MOBILE
    }), '&.EmbersHeader-tablet', {
      '.EmbersHeader-app': {
        padding: 10
      },
      '.EmbersHeader-mainContent': {
        '.EmbersHeader-logo': {
          margin: '0 6px' // 8px with transparent border
        },
        '.EmbersHeader-rightContent': {
          '.EmbersHeader-avatar-root': {
            marginLeft: 16
          }
        }
      }
    }), '&:focus-visible', {
      '.icon-apps': {
        display: 'none'
      },
      '.icon-apps-fill': {
        border: "2px solid ".concat(PROMETHEAN_NEUTRAL_WHITE),
        display: 'block'
      }
    }),
    '.EmbersHeader-app-appSwitcherOpen': {
      '.icon-apps': {
        display: 'none'
      },
      '.icon-apps-fill': {
        display: 'block'
      },
      '&:focus-visible': {
        '.icon-apps': {
          display: 'none'
        },
        '.icon-apps-fill': {
          border: "2px solid ".concat(PROMETHEAN_NEUTRAL_WHITE),
          display: 'block'
        }
      }
    }
  };
});
export var StyledSimpleHeader = styled('div')({
  '&.EmbersSimpleHeader-root': {
    width: '100%',
    height: EMBERS_SIMPLE_HEADER_HEIGHT,
    backgroundColor: PROMETHEAN_DARK_PURPLE,
    position: 'fixed',
    zIndex: 1300,
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    '.EmbersHeader-logo': {
      margin: '0 22px',
      // 24px with transparent border
      position: 'relative',
      zIndex: 1,
      width: 167,
      height: 44
    },
    '.EmbersHeader-flames': {
      display: 'block',
      position: 'absolute',
      right: 0,
      top: 0
    }
  }
});
export var SkipToMainContent = styled('a')(_objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_BODY), {}, {
  textDecoration: 'none',
  position: 'absolute',
  left: '-999px',
  zIndex: 9999,
  padding: '4px 12px',
  backgroundColor: PROMETHEAN_NEUTRAL_WHITE,
  border: "2px solid ".concat(PROMETHEAN_BLUE),
  borderRadius: 8,
  opacity: 0,
  '&:focus-visible': {
    top: 9,
    left: 12,
    opacity: 1
  }
}));